import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, AtualizarParametroLocalidade } from './types';

export const INITIAL_STATE: AtualizarParametroLocalidade = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): AtualizarParametroLocalidade {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_PARAMETRO_LOCALIDADE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.ATUALIZAR_PARAMETRO_LOCALIDADE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.ATUALIZAR_PARAMETRO_LOCALIDADE_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_PARAMETRO_LOCALIDADE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
	});
}
